import _asyncToGenerator from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { clearGlobalDnDState as $7252cd45fc48c07c$export$70936501603e6c57, DIRECTORY_DRAG_TYPE as $7252cd45fc48c07c$export$990fced5dfac2637, droppableCollectionMap as $7252cd45fc48c07c$export$dfdf5deeaf27473f, getTypes as $7252cd45fc48c07c$export$e1d41611756c6326, globalDndState as $7252cd45fc48c07c$export$6ca6700462636d0b, isInternalDropOperation as $7252cd45fc48c07c$export$78bf638634500fa5, setDropCollectionRef as $7252cd45fc48c07c$export$dac8db29d42db9a1 } from "./utils.module.js";
import { registerDropTarget as $67560de7c78cb232$export$c28d9fb4a54e471a } from "./DragManager.module.js";
import { useAutoScroll as $80d9daea3067eff3$export$6323452ca4533ed8 } from "./useAutoScroll.module.js";
import { useDrop as $5c06e4929e123553$export$ccdee5eaf73cf661 } from "./useDrop.module.js";
import { useRef as $4ZR0C$useRef, useCallback as $4ZR0C$useCallback, useEffect as $4ZR0C$useEffect } from "react";
import { useLayoutEffect as $4ZR0C$useLayoutEffect, useId as $4ZR0C$useId, mergeProps as $4ZR0C$mergeProps } from "@react-aria/utils";
import { setInteractionModality as $4ZR0C$setInteractionModality } from "@react-aria/interactions";
import { useLocale as $4ZR0C$useLocale } from "@react-aria/i18n";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $4b52e4eff84e5217$var$DROP_POSITIONS = ['before', 'on', 'after'];
var $4b52e4eff84e5217$var$DROP_POSITIONS_RTL = ['after', 'on', 'before'];
function $4b52e4eff84e5217$export$f4e2f423c21f7b04(props, state, ref) {
  var localState = (0, $4ZR0C$useRef)({
    props: props,
    state: state,
    nextTarget: null,
    dropOperation: null
  }).current;
  localState.props = props;
  localState.state = state;
  var defaultOnDrop = (0, $4ZR0C$useCallback)(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var _localState$props, onInsert, onRootDrop, onItemDrop, onReorder, _localState$props$acc, acceptedDragTypes, shouldAcceptItemDrop, _ref2, draggingKeys, isInternal, target, dropOperation, items, filteredItems;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _localState$props = localState.props, onInsert = _localState$props.onInsert, onRootDrop = _localState$props.onRootDrop, onItemDrop = _localState$props.onItemDrop, onReorder = _localState$props.onReorder, _localState$props$acc = _localState$props.acceptedDragTypes, acceptedDragTypes = _localState$props$acc === void 0 ? 'all' : _localState$props$acc, shouldAcceptItemDrop = _localState$props.shouldAcceptItemDrop;
            _ref2 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b), draggingKeys = _ref2.draggingKeys;
            isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
            target = e.target, dropOperation = e.dropOperation, items = e.items;
            filteredItems = items;
            if (acceptedDragTypes !== 'all' || shouldAcceptItemDrop) filteredItems = items.filter(function (item) {
              var itemTypes;
              if (item.kind === 'directory') itemTypes = new Set([(0, $7252cd45fc48c07c$export$990fced5dfac2637)]);else itemTypes = item.kind === 'file' ? new Set([item.type]) : item.types;
              if (acceptedDragTypes === 'all' || acceptedDragTypes.some(function (type) {
                return itemTypes.has(type);
              })) {
                // If we are performing a on item drop, check if the item in question accepts the dropped item since the item may have heavier restrictions
                // than the droppable collection itself
                if (target.type === 'item' && target.dropPosition === 'on' && shouldAcceptItemDrop) return shouldAcceptItemDrop(target, itemTypes);
                return true;
              }
              return false;
            });
            if (!(filteredItems.length > 0)) {
              _context.next = 21;
              break;
            }
            if (!(target.type === 'root' && onRootDrop)) {
              _context.next = 10;
              break;
            }
            _context.next = 10;
            return onRootDrop({
              items: filteredItems,
              dropOperation: dropOperation
            });
          case 10:
            if (!(target.type === 'item')) {
              _context.next = 21;
              break;
            }
            if (!(target.dropPosition === 'on' && onItemDrop)) {
              _context.next = 14;
              break;
            }
            _context.next = 14;
            return onItemDrop({
              items: filteredItems,
              dropOperation: dropOperation,
              isInternal: isInternal,
              target: target
            });
          case 14:
            if (!(target.dropPosition !== 'on')) {
              _context.next = 21;
              break;
            }
            if (!(!isInternal && onInsert)) {
              _context.next = 18;
              break;
            }
            _context.next = 18;
            return onInsert({
              items: filteredItems,
              dropOperation: dropOperation,
              target: target
            });
          case 18:
            if (!(isInternal && onReorder)) {
              _context.next = 21;
              break;
            }
            _context.next = 21;
            return onReorder({
              keys: draggingKeys,
              dropOperation: dropOperation,
              target: target
            });
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [localState, ref]);
  var autoScroll = (0, $80d9daea3067eff3$export$6323452ca4533ed8)(ref);
  var _ref3 = (0, $5c06e4929e123553$export$ccdee5eaf73cf661)({
      ref: ref,
      onDropEnter: function onDropEnter() {
        state.setTarget(localState.nextTarget);
      },
      onDropMove: function onDropMove(e) {
        state.setTarget(localState.nextTarget);
        autoScroll.move(e.x, e.y);
      },
      getDropOperationForPoint: function getDropOperationForPoint(types, allowedOperations, x, y) {
        var _ref4 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
          draggingKeys = _ref4.draggingKeys,
          dropCollectionRef = _ref4.dropCollectionRef;
        var isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
        var isValidDropTarget = function isValidDropTarget(target) {
          return state.getDropOperation({
            target: target,
            types: types,
            allowedOperations: allowedOperations,
            isInternal: isInternal,
            draggingKeys: draggingKeys
          }) !== 'cancel';
        };
        var target = props.dropTargetDelegate.getDropTargetFromPoint(x, y, isValidDropTarget);
        if (!target) {
          localState.dropOperation = 'cancel';
          localState.nextTarget = null;
          return 'cancel';
        }
        localState.dropOperation = state.getDropOperation({
          target: target,
          types: types,
          allowedOperations: allowedOperations,
          isInternal: isInternal,
          draggingKeys: draggingKeys
        });
        // If the target doesn't accept the drop, see if the root accepts it instead.
        if (localState.dropOperation === 'cancel') {
          var rootTarget = {
            type: 'root'
          };
          var dropOperation = state.getDropOperation({
            target: rootTarget,
            types: types,
            allowedOperations: allowedOperations,
            isInternal: isInternal,
            draggingKeys: draggingKeys
          });
          if (dropOperation !== 'cancel') {
            target = rootTarget;
            localState.dropOperation = dropOperation;
          }
        }
        // Only set dropCollectionRef if there is a valid drop target since we cleanup dropCollectionRef in onDropExit
        // which only runs when leaving a valid drop target or if the dropEffect become none (mouse dnd only).
        if (target && localState.dropOperation !== 'cancel' && (ref === null || ref === void 0 ? void 0 : ref.current) !== (dropCollectionRef === null || dropCollectionRef === void 0 ? void 0 : dropCollectionRef.current)) (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(ref);
        localState.nextTarget = localState.dropOperation === 'cancel' ? null : target;
        return localState.dropOperation;
      },
      onDropExit: function onDropExit() {
        (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(undefined);
        state.setTarget(null);
        autoScroll.stop();
      },
      onDropActivate: function onDropActivate(e) {
        var _state_target, _state_target1;
        if (((_state_target = state.target) === null || _state_target === void 0 ? void 0 : _state_target.type) === 'item' && ((_state_target1 = state.target) === null || _state_target1 === void 0 ? void 0 : _state_target1.dropPosition) === 'on' && typeof props.onDropActivate === 'function') props.onDropActivate({
          type: 'dropactivate',
          x: e.x,
          y: e.y,
          target: state.target
        });
      },
      onDrop: function onDrop(e) {
        (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(ref);
        if (state.target) _onDrop(e, state.target);
        // If there wasn't a collection being tracked as a dragged collection, then we are in a case where a non RSP drag is dropped on a
        // RSP collection and thus we don't need to preserve the global DnD state for onDragEnd
        var _ref5 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
          draggingCollectionRef = _ref5.draggingCollectionRef;
        if (draggingCollectionRef == null) (0, $7252cd45fc48c07c$export$70936501603e6c57)();
      }
    }),
    dropProps = _ref3.dropProps;
  var droppingState = (0, $4ZR0C$useRef)(null);
  var updateFocusAfterDrop = (0, $4ZR0C$useCallback)(function () {
    var state = localState.state;
    if (droppingState.current) {
      var _state_collection_getItem;
      var _droppingState$curren = droppingState.current,
        target = _droppingState$curren.target,
        prevCollection = _droppingState$curren.collection,
        prevSelectedKeys = _droppingState$curren.selectedKeys,
        prevFocusedKey = _droppingState$curren.focusedKey,
        isInternal = _droppingState$curren.isInternal,
        draggingKeys = _droppingState$curren.draggingKeys; // If an insert occurs during a drop, we want to immediately select these items to give
      // feedback to the user that a drop occurred. Only do this if the selection didn't change
      // since the drop started so we don't override if the user or application did something.
      if (state.collection.size > prevCollection.size && state.selectionManager.isSelectionEqual(prevSelectedKeys)) {
        var newKeys = new Set();
        var _iterator = _createForOfIteratorHelper(state.collection.getKeys()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var key = _step.value;
            if (!prevCollection.getItem(key)) newKeys.add(key);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        state.selectionManager.setSelectedKeys(newKeys);
        // If the focused item didn't change since the drop occurred, also focus the first
        // inserted item. If selection is disabled, then also show the focus ring so there
        // is some indication that items were added.
        if (state.selectionManager.focusedKey === prevFocusedKey) {
          var first = newKeys.keys().next().value;
          var item = state.collection.getItem(first);
          // If this is a cell, focus the parent row.
          if ((item === null || item === void 0 ? void 0 : item.type) === 'cell') first = item.parentKey;
          state.selectionManager.setFocusedKey(first);
          if (state.selectionManager.selectionMode === 'none') (0, $4ZR0C$setInteractionModality)('keyboard');
        }
      } else if (state.selectionManager.focusedKey === prevFocusedKey && isInternal && target.type === 'item' && target.dropPosition !== 'on' && draggingKeys.has((_state_collection_getItem = state.collection.getItem(prevFocusedKey)) === null || _state_collection_getItem === void 0 ? void 0 : _state_collection_getItem.parentKey)) {
        // Focus row instead of cell when reordering.
        state.selectionManager.setFocusedKey(state.collection.getItem(prevFocusedKey).parentKey);
        (0, $4ZR0C$setInteractionModality)('keyboard');
      } else if (state.selectionManager.focusedKey === prevFocusedKey && target.type === 'item' && target.dropPosition === 'on' && state.collection.getItem(target.key) != null) {
        // If focus didn't move already (e.g. due to an insert), and the user dropped on an item,
        // focus that item and show the focus ring to give the user feedback that the drop occurred.
        // Also show the focus ring if the focused key is not selected, e.g. in case of a reorder.
        state.selectionManager.setFocusedKey(target.key);
        (0, $4ZR0C$setInteractionModality)('keyboard');
      } else if (!state.selectionManager.isSelected(state.selectionManager.focusedKey)) (0, $4ZR0C$setInteractionModality)('keyboard');
      state.selectionManager.setFocused(true);
    }
  }, [localState]);
  var _onDrop = (0, $4ZR0C$useCallback)(function (e, target) {
    var state = localState.state; // Save some state of the collection/selection before the drop occurs so we can compare later.
    droppingState.current = {
      timeout: null,
      focusedKey: state.selectionManager.focusedKey,
      collection: state.collection,
      selectedKeys: state.selectionManager.selectedKeys,
      draggingKeys: (0, $7252cd45fc48c07c$export$6ca6700462636d0b).draggingKeys,
      isInternal: (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref),
      target: target
    };
    var onDropFn = localState.props.onDrop || defaultOnDrop;
    onDropFn({
      type: 'drop',
      x: e.x,
      y: e.y,
      target: target,
      items: e.items,
      dropOperation: e.dropOperation
    });
    // Wait for a short time period after the onDrop is called to allow the data to be read asynchronously
    // and for React to re-render. If the collection didn't already change during this time (handled below),
    // update the focused key here.
    droppingState.current.timeout = setTimeout(function () {
      updateFocusAfterDrop();
      droppingState.current = null;
    }, 50);
  }, [localState, defaultOnDrop, ref, updateFocusAfterDrop]);
  // eslint-disable-next-line arrow-body-style
  (0, $4ZR0C$useEffect)(function () {
    return function () {
      if (droppingState.current) clearTimeout(droppingState.current.timeout);
    };
  }, []);
  (0, $4ZR0C$useLayoutEffect)(function () {
    // If the collection changed after a drop, update the focused key.
    if (droppingState.current && state.collection !== droppingState.current.collection) updateFocusAfterDrop();
  });
  var _ref6 = (0, $4ZR0C$useLocale)(),
    direction = _ref6.direction;
  (0, $4ZR0C$useEffect)(function () {
    var getNextTarget = function getNextTarget(target) {
      var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var horizontal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!target) return {
        type: 'root'
      };
      var keyboardDelegate = localState.props.keyboardDelegate;
      var nextKey;
      if ((target === null || target === void 0 ? void 0 : target.type) === 'item') nextKey = horizontal ? keyboardDelegate.getKeyRightOf(target.key) : keyboardDelegate.getKeyBelow(target.key);else nextKey = horizontal && direction === 'rtl' ? keyboardDelegate.getLastKey() : keyboardDelegate.getFirstKey();
      var dropPositions = horizontal && direction === 'rtl' ? $4b52e4eff84e5217$var$DROP_POSITIONS_RTL : $4b52e4eff84e5217$var$DROP_POSITIONS;
      var dropPosition = dropPositions[0];
      if (target.type === 'item') {
        // If the the keyboard delegate returned the next key in the collection,
        // first try the other positions in the current key. Otherwise (e.g. in a grid layout),
        // jump to the same drop position in the new key.
        var nextCollectionKey = horizontal && direction === 'rtl' ? localState.state.collection.getKeyBefore(target.key) : localState.state.collection.getKeyAfter(target.key);
        if (nextKey == null || nextKey === nextCollectionKey) {
          var positionIndex = dropPositions.indexOf(target.dropPosition);
          var nextDropPosition = dropPositions[positionIndex + 1];
          if (positionIndex < dropPositions.length - 1 && !(nextDropPosition === dropPositions[2] && nextKey != null)) return {
            type: 'item',
            key: target.key,
            dropPosition: nextDropPosition
          };
          // If the last drop position was 'after', then 'before' on the next key is equivalent.
          // Switch to 'on' instead.
          if (target.dropPosition === dropPositions[2]) dropPosition = 'on';
        } else dropPosition = target.dropPosition;
      }
      if (nextKey == null) {
        if (wrap) return {
          type: 'root'
        };
        return null;
      }
      return {
        type: 'item',
        key: nextKey,
        dropPosition: dropPosition
      };
    };
    var getPreviousTarget = function getPreviousTarget(target) {
      var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var horizontal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var keyboardDelegate = localState.props.keyboardDelegate;
      var nextKey;
      if ((target === null || target === void 0 ? void 0 : target.type) === 'item') nextKey = horizontal ? keyboardDelegate.getKeyLeftOf(target.key) : keyboardDelegate.getKeyAbove(target.key);else nextKey = horizontal && direction === 'rtl' ? keyboardDelegate.getFirstKey() : keyboardDelegate.getLastKey();
      var dropPositions = horizontal && direction === 'rtl' ? $4b52e4eff84e5217$var$DROP_POSITIONS_RTL : $4b52e4eff84e5217$var$DROP_POSITIONS;
      var dropPosition = !target || target.type === 'root' ? dropPositions[2] : 'on';
      if ((target === null || target === void 0 ? void 0 : target.type) === 'item') {
        // If the the keyboard delegate returned the previous key in the collection,
        // first try the other positions in the current key. Otherwise (e.g. in a grid layout),
        // jump to the same drop position in the new key.
        var prevCollectionKey = horizontal && direction === 'rtl' ? localState.state.collection.getKeyAfter(target.key) : localState.state.collection.getKeyBefore(target.key);
        if (nextKey == null || nextKey === prevCollectionKey) {
          var positionIndex = dropPositions.indexOf(target.dropPosition);
          var nextDropPosition = dropPositions[positionIndex - 1];
          if (positionIndex > 0 && nextDropPosition !== dropPositions[2]) return {
            type: 'item',
            key: target.key,
            dropPosition: nextDropPosition
          };
          // If the last drop position was 'before', then 'after' on the previous key is equivalent.
          // Switch to 'on' instead.
          if (target.dropPosition === dropPositions[0]) dropPosition = 'on';
        } else dropPosition = target.dropPosition;
      }
      if (nextKey == null) {
        if (wrap) return {
          type: 'root'
        };
        return null;
      }
      return {
        type: 'item',
        key: nextKey,
        dropPosition: dropPosition
      };
    };
    var nextValidTarget = function nextValidTarget(target, types, allowedDropOperations, getNextTarget) {
      var wrap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var seenRoot = 0;
      var operation;
      var _ref7 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
        draggingKeys = _ref7.draggingKeys;
      var isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
      do {
        var nextTarget = getNextTarget(target, wrap);
        if (!nextTarget) return null;
        target = nextTarget;
        operation = localState.state.getDropOperation({
          target: nextTarget,
          types: types,
          allowedOperations: allowedDropOperations,
          isInternal: isInternal,
          draggingKeys: draggingKeys
        });
        if (target.type === 'root') seenRoot++;
      } while (operation === 'cancel' && !localState.state.isDropTarget(target) && seenRoot < 2);
      if (operation === 'cancel') return null;
      return target;
    };
    return $67560de7c78cb232$export$c28d9fb4a54e471a({
      element: ref.current,
      preventFocusOnDrop: true,
      getDropOperation: function getDropOperation(types, allowedOperations) {
        if (localState.state.target) {
          var _ref8 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
            draggingKeys = _ref8.draggingKeys;
          var isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
          return localState.state.getDropOperation({
            target: localState.state.target,
            types: types,
            allowedOperations: allowedOperations,
            isInternal: isInternal,
            draggingKeys: draggingKeys
          });
        }
        // Check if any of the targets accept the drop.
        // TODO: should we have a faster way of doing this or e.g. for pagination?
        var target = nextValidTarget(null, types, allowedOperations, getNextTarget);
        return target ? 'move' : 'cancel';
      },
      onDropEnter: function onDropEnter(e, drag) {
        var types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(drag.items);
        var selectionManager = localState.state.selectionManager;
        var target;
        // Update the drop collection ref tracker for useDroppableItem's getDropOperation isInternal check
        (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(ref);
        // When entering the droppable collection for the first time, the default drop target
        // is after the focused key.
        var key = selectionManager.focusedKey;
        var dropPosition = 'after';
        // If the focused key is a cell, get the parent item instead.
        // For now, we assume that individual cells cannot be dropped on.
        var item = localState.state.collection.getItem(key);
        if ((item === null || item === void 0 ? void 0 : item.type) === 'cell') key = item.parentKey;
        // If the focused item is also selected, the default drop target is after the last selected item.
        // But if the focused key is the first selected item, then default to before the first selected item.
        // This is to make reordering lists slightly easier. If you select top down, we assume you want to
        // move the items down. If you select bottom up, we assume you want to move the items up.
        if (selectionManager.isSelected(key)) {
          if (selectionManager.selectedKeys.size > 1 && selectionManager.firstSelectedKey === key) dropPosition = 'before';else key = selectionManager.lastSelectedKey;
        }
        if (key != null) {
          target = {
            type: 'item',
            key: key,
            dropPosition: dropPosition
          };
          var _ref9 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
            draggingKeys = _ref9.draggingKeys;
          var isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
          var _nextValidTarget;
          // If the default target is not valid, find the next one that is.
          if (localState.state.getDropOperation({
            target: target,
            types: types,
            allowedOperations: drag.allowedDropOperations,
            isInternal: isInternal,
            draggingKeys: draggingKeys
          }) === 'cancel') target = (_nextValidTarget = nextValidTarget(target, types, drag.allowedDropOperations, getNextTarget, false)) !== null && _nextValidTarget !== void 0 ? _nextValidTarget : nextValidTarget(target, types, drag.allowedDropOperations, getPreviousTarget, false);
        }
        // If no focused key, then start from the root.
        if (!target) target = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
        localState.state.setTarget(target);
      },
      onDropExit: function onDropExit() {
        (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(undefined);
        localState.state.setTarget(null);
      },
      onDropTargetEnter: function onDropTargetEnter(target) {
        localState.state.setTarget(target);
      },
      onDropActivate: function onDropActivate(e) {
        var _localState_state_target, _localState_state_target1;
        if (((_localState_state_target = localState.state.target) === null || _localState_state_target === void 0 ? void 0 : _localState_state_target.type) === 'item' && ((_localState_state_target1 = localState.state.target) === null || _localState_state_target1 === void 0 ? void 0 : _localState_state_target1.dropPosition) === 'on' && typeof localState.props.onDropActivate === 'function') localState.props.onDropActivate({
          type: 'dropactivate',
          x: e.x,
          y: e.y,
          target: localState.state.target
        });
      },
      onDrop: function onDrop(e, target) {
        (0, $7252cd45fc48c07c$export$dac8db29d42db9a1)(ref);
        if (localState.state.target) _onDrop(e, target || localState.state.target);
      },
      onKeyDown: function onKeyDown(e, drag) {
        var keyboardDelegate = localState.props.keyboardDelegate;
        var types = (0, $7252cd45fc48c07c$export$e1d41611756c6326)(drag.items);
        switch (e.key) {
          case 'ArrowDown':
            if (keyboardDelegate.getKeyBelow) {
              var target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, getNextTarget);
              localState.state.setTarget(target);
            }
            break;
          case 'ArrowUp':
            if (keyboardDelegate.getKeyAbove) {
              var _target = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, getPreviousTarget);
              localState.state.setTarget(_target);
            }
            break;
          case 'ArrowLeft':
            if (keyboardDelegate.getKeyLeftOf) {
              var _target2 = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, function (target, wrap) {
                return getPreviousTarget(target, wrap, true);
              });
              localState.state.setTarget(_target2);
            }
            break;
          case 'ArrowRight':
            if (keyboardDelegate.getKeyRightOf) {
              var _target3 = nextValidTarget(localState.state.target, types, drag.allowedDropOperations, function (target, wrap) {
                return getNextTarget(target, wrap, true);
              });
              localState.state.setTarget(_target3);
            }
            break;
          case 'Home':
            if (keyboardDelegate.getFirstKey) {
              var _target4 = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);
              localState.state.setTarget(_target4);
            }
            break;
          case 'End':
            if (keyboardDelegate.getLastKey) {
              var _target5 = nextValidTarget(null, types, drag.allowedDropOperations, getPreviousTarget);
              localState.state.setTarget(_target5);
            }
            break;
          case 'PageDown':
            if (keyboardDelegate.getKeyPageBelow) {
              var _target6 = localState.state.target;
              if (!_target6) _target6 = nextValidTarget(null, types, drag.allowedDropOperations, getNextTarget);else {
                // If on the root, go to the item a page below the top. Otherwise a page below the current item.
                var nextKey = keyboardDelegate.getKeyPageBelow(_target6.type === 'item' ? _target6.key : keyboardDelegate.getFirstKey());
                var dropPosition = _target6.type === 'item' ? _target6.dropPosition : 'after';
                // If there is no next key, or we are starting on the last key, jump to the last possible position.
                if (nextKey == null || _target6.type === 'item' && _target6.key === keyboardDelegate.getLastKey()) {
                  nextKey = keyboardDelegate.getLastKey();
                  dropPosition = 'after';
                }
                _target6 = {
                  type: 'item',
                  key: nextKey,
                  dropPosition: dropPosition
                };
                // If the target does not accept the drop, find the next valid target.
                // If no next valid target, find the previous valid target.
                var _ref10 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
                  draggingCollectionRef = _ref10.draggingCollectionRef,
                  draggingKeys = _ref10.draggingKeys;
                var isInternal = (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) === (ref === null || ref === void 0 ? void 0 : ref.current);
                var operation = localState.state.getDropOperation({
                  target: _target6,
                  types: types,
                  allowedOperations: drag.allowedDropOperations,
                  isInternal: isInternal,
                  draggingKeys: draggingKeys
                });
                var _nextValidTarget;
                if (operation === 'cancel') _target6 = (_nextValidTarget = nextValidTarget(_target6, types, drag.allowedDropOperations, getNextTarget, false)) !== null && _nextValidTarget !== void 0 ? _nextValidTarget : nextValidTarget(_target6, types, drag.allowedDropOperations, getPreviousTarget, false);
              }
              localState.state.setTarget(_target6 !== null && _target6 !== void 0 ? _target6 : localState.state.target);
            }
            break;
          case 'PageUp':
            {
              if (!keyboardDelegate.getKeyPageAbove) break;
              var _target7 = localState.state.target;
              if (!_target7) _target7 = nextValidTarget(null, types, drag.allowedDropOperations, getPreviousTarget);else if (_target7.type === 'item') {
                // If at the top already, switch to the root. Otherwise navigate a page up.
                if (_target7.key === keyboardDelegate.getFirstKey()) _target7 = {
                  type: 'root'
                };else {
                  var _nextKey = keyboardDelegate.getKeyPageAbove(_target7.key);
                  var _dropPosition = _target7.dropPosition;
                  if (_nextKey == null) {
                    _nextKey = keyboardDelegate.getFirstKey();
                    _dropPosition = 'before';
                  }
                  _target7 = {
                    type: 'item',
                    key: _nextKey,
                    dropPosition: _dropPosition
                  };
                }
                // If the target does not accept the drop, find the previous valid target.
                // If no next valid target, find the next valid target.
                var _ref11 = (0, $7252cd45fc48c07c$export$6ca6700462636d0b),
                  _draggingKeys = _ref11.draggingKeys;
                var _isInternal = (0, $7252cd45fc48c07c$export$78bf638634500fa5)(ref);
                var _operation = localState.state.getDropOperation({
                  target: _target7,
                  types: types,
                  allowedOperations: drag.allowedDropOperations,
                  isInternal: _isInternal,
                  draggingKeys: _draggingKeys
                });
                var _nextValidTarget1;
                if (_operation === 'cancel') _target7 = (_nextValidTarget1 = nextValidTarget(_target7, types, drag.allowedDropOperations, getPreviousTarget, false)) !== null && _nextValidTarget1 !== void 0 ? _nextValidTarget1 : nextValidTarget(_target7, types, drag.allowedDropOperations, getNextTarget, false);
              }
              localState.state.setTarget(_target7 !== null && _target7 !== void 0 ? _target7 : localState.state.target);
              break;
            }
        }
      }
    });
  }, [localState, ref, _onDrop, direction]);
  var id = (0, $4ZR0C$useId)();
  (0, $7252cd45fc48c07c$export$dfdf5deeaf27473f).set(state, {
    id: id,
    ref: ref
  });
  return {
    collectionProps: (0, $4ZR0C$mergeProps)(dropProps, {
      id: id,
      // Remove description from collection element. If dropping on the entire collection,
      // there should be a drop indicator that has this description, so no need to double announce.
      'aria-describedby': null
    })
  };
}
export { $4b52e4eff84e5217$export$f4e2f423c21f7b04 as useDroppableCollection };